import { SVGProps } from "react";

export const ThreeFriendsIcon = (props: SVGProps<SVGSVGElement>) => {
    return <svg width="73rem" height="74rem" viewBox="0 0 73 74" fill="none" {...props}>
        <rect x="0.5" y="19.5" width="39" height="39" rx="19.4789" fill="url(#paint0_radial_6022_1954)" stroke="url(#paint1_linear_6022_1954)" />
        <g filter="url(#filter0_d_6022_1954)">
            <circle cx="11.9707" cy="30.9708" r="3.05407" fill="white" />
            <circle cx="27.6123" cy="30.9708" r="3.05407" fill="white" />
        </g>
        <g filter="url(#filter1_d_6022_1954)">
            <path d="M18 34C18 35.1046 18.8954 36 20 36C21.1046 36 22 35.1046 22 34" stroke="white" strokeLinecap="round" />
        </g>
        <rect x="33.5" y="34.5" width="39" height="39" rx="19.4789" fill="url(#paint2_radial_6022_1954)" stroke="url(#paint3_linear_6022_1954)" />
        <g filter="url(#filter2_d_6022_1954)">
            <circle cx="44.9707" cy="45.9708" r="3.05407" fill="white" />
            <circle cx="60.6123" cy="45.9708" r="3.05407" fill="white" />
        </g>
        <g filter="url(#filter3_d_6022_1954)">
            <path d="M51 49C51 50.1046 51.8954 51 53 51C54.1046 51 55 50.1046 55 49" stroke="white" strokeLinecap="round" />
        </g>
        <rect x="27.5" y="0.5" width="39" height="39" rx="19.4789" fill="url(#paint4_radial_6022_1954)" stroke="url(#paint5_linear_6022_1954)" />
        <g filter="url(#filter4_d_6022_1954)">
            <circle cx="38.9707" cy="11.9708" r="3.05407" fill="white" />
            <circle cx="54.6123" cy="11.9708" r="3.05407" fill="white" />
        </g>
        <g filter="url(#filter5_d_6022_1954)">
            <path d="M45 15C45 16.1046 45.8954 17 47 17C48.1046 17 49 16.1046 49 15" stroke="white" strokeLinecap="round" />
        </g>
        <defs>
            <filter id="filter0_d_6022_1954" x="6.56066" y="25.5607" width="26.4617" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6022_1954" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6022_1954" result="shape" />
            </filter>
            <filter id="filter1_d_6022_1954" x="15.144" y="31.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6022_1954" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6022_1954" result="shape" />
            </filter>
            <filter id="filter2_d_6022_1954" x="39.5607" y="40.5607" width="26.4617" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6022_1954" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6022_1954" result="shape" />
            </filter>
            <filter id="filter3_d_6022_1954" x="48.144" y="46.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6022_1954" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6022_1954" result="shape" />
            </filter>
            <filter id="filter4_d_6022_1954" x="33.5607" y="6.56069" width="26.4617" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6022_1954" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6022_1954" result="shape" />
            </filter>
            <filter id="filter5_d_6022_1954" x="42.144" y="12.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="1.178" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6022_1954" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6022_1954" result="shape" />
            </filter>
            <radialGradient id="paint0_radial_6022_1954" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20 38) rotate(90) scale(20)">
                <stop stopColor="#D9D9D9" stopOpacity="0.68" />
                <stop offset="1" stopColor="#737373" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="paint1_linear_6022_1954" x1="20" y1="20" x2="20" y2="58" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#999999" stopOpacity="0" />
            </linearGradient>
            <radialGradient id="paint2_radial_6022_1954" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(53 53) rotate(90) scale(20)">
                <stop stopColor="#D9D9D9" stopOpacity="0.68" />
                <stop offset="1" stopColor="#737373" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="paint3_linear_6022_1954" x1="53" y1="35" x2="53" y2="73" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#999999" stopOpacity="0" />
            </linearGradient>
            <radialGradient id="paint4_radial_6022_1954" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(47 19) rotate(90) scale(20)">
                <stop stopColor="#D9D9D9" stopOpacity="0.68" />
                <stop offset="1" stopColor="#737373" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="paint5_linear_6022_1954" x1="47" y1="1" x2="47" y2="39" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="#999999" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>

}